export default "__VITE_ASSET__67fa4a18__"